'use client'

import { NavContext } from "@/context/navContext"
import api from "@/util/api"
import { useContext, useEffect, useState } from "react"
import VerifiedRankListComponent from "../float/verified_right"
import { useTranslations } from "next-intl"


interface verifiedRankData {
    id: number,
    name: string,
    rank_info: verifiedRankListType[]
}
interface verifiedRankListType {
    create_dt: string,
    id: number,
    rank: number,
    site: string,
    verifiedsite_logo:string
}

export default function VerifiedRankList({ setActive }: { setActive: Function }) {
    const [list, setList] = useState<verifiedRankData[]>([])
    const { movePage } = useContext(NavContext)

    const p = useTranslations("PageTitle")

    function fetchData(){
        api(`/api/verified/rank/`)
            .then(res=> res.json())
            .then(({data})=> {
                // console.log(data.objects)
                setList(Array.isArray(data?.objects) ? data.objects : [])
            })
    }
    

    useEffect(()=> {
        fetchData();
    },[])

    return (
        <>
        
            {list.length > 0 && 
            <>
                <div className={`mypage_title m-b-1`}>{p("스폰랭킹")}</div>
                <div className={`mypage_box`}>
                    <VerifiedRankListComponent
                        list={list}
                        setActive={(active: boolean) => setActive(active)} />
                </div>
            </>
            }
        </>
    )
}